<template>
  <div class="content">
    <div class="container-fluid">
      <div class="col-12">
        <card class="card-plain">

          <template slot="header">
            <h4 class="card-title">Overview</h4>
            <p class="card-category"></p>
          </template>

        </card>
      </div>
    </div>
  </div>
</template>

<script>

  const dataColumns = ['Date', 'Type', 'Status'];

  export default {
    name: "OverviewPage",

    data() {
      return {
        dataColumns: [...dataColumns],
        todayData: [],
        yesterdayData: [],
        overviewData: []
      }
    },
    mounted() {
      // this.loadChart();
      // this.loadStrategiesSummaries();

      this.loadOverview();
    },

    methods: {
      loadOverview() {
        this.$http.get('overview')
          .then(result => {
            this.overviewData.pop();
          }, error => {
            console.error(error);
          });
      },
    }
  }
</script>
<style>
  .content {
    width: 100%;
    background: #f8f9fa;
  }

  .card-plain {
    margin-bottom: inherit;
  }

  .table-responsive {
    background: whitesmoke;
    border-color: #0e0e0e;
  }

  .card-body {
    background: #f8f9fa;
  }

  .cardPlain {
    margin: 10px;
    margin-top: 20px;
    background-color: #e5e5e5;
  }

  h5 {
    background: #E3E3E3;
  }

  .headStyle {
    background: cadetblue;
  }
</style>
